import React from 'react';
import makeStyles from '@mui/styles/makeStyles';

const customStyle = makeStyles((theme) => ({
	card: {
		borderRadius: 22,
		background: "linear-gradient(rgb(48, 50, 62), rgb(30, 31, 42))",
		width: 340,
		height: 200,
		margin: 20,
		boxShadow: "rgb(0 0 0 / 69%) 0px 26px 30px -10px, rgb(0 0 0 / 73%) 0px 16px 10px -10px",
		border: "3px solid rgb(58, 60, 74)",
		padding: 22,
		transition: "all 250ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 0s !important",
		transform: "scale(1)",
		cursor: "pointer",
		display: "flex",
		position: "relative",
		"&:hover": {
			border: "3px solid rgb(133 136 154)",
			transform: "scale(1.05)",
			boxShadow: "rgb(0 0 0 / 69%) 0px 36px 40px -20px, rgb(0 0 0 / 73%) 0px 26px 20px -20px",
			"& $image": {
				display: "block"
			},
		},
		[theme.breakpoints.down('lg')]: {
			width: "100%",
			margin: 4,
			marginBottom: 20,
		}
	},
	image: {
		width: "100%",
		height: "100%",
		opacity: "0",
		margin: "auto",
		position: "absolute",
		top: 0,
		left: 0,
		borderRadius: 22,
		display: "none",
		transform: "scale(0.8)",
		zIndex: 1000,
		transition: "all 100ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 0s !important",
		"&:hover": {
			opacity: "1",
			transform: "scale(1)",
		}
	},
	faq: {
		borderRadius: 40,
		background: "linear-gradient(rgb(48, 50, 62), rgb(30, 31, 42))",
		width: "100%",
		height: 80,
		margin: 20,
		boxShadow: "rgb(0 0 0 / 69%) 0px 26px 30px -10px, rgb(0 0 0 / 73%) 0px 16px 10px -10px",
		border: "3px solid rgb(58, 60, 74)",
		padding: 22,
		transition: "all 250ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 0s !important",
		transform: "scale(1)",
		cursor: "pointer",
		"&:hover": {
			border: "3px solid rgb(133 136 154)",
			transform: "scale(1.05)",
			boxShadow: "rgb(0 0 0 / 69%) 0px 36px 40px -20px, rgb(0 0 0 / 73%) 0px 26px 20px -20px",
		},
		[theme.breakpoints.down('lg')]: {
			width: "100%",
			margin: 4,
			marginBottom: 20,
		}
	},
	mainTitle: {
		fontSize: 98,
		[theme.breakpoints.down('lg')]: {
			fontSize: 38,
		}
	},
	subTitle: {
		paddingLeft: 120,
		paddingRight: 120,
		color: "rgb(148,151,168)",
		fontSize: 18,
		[theme.breakpoints.down('lg')]: {
			fontSize: 18,
			paddingLeft: 18,
			paddingRight: 18,
		}
	},
	categoryName: {
		fontSize: 28,
		margin: "auto",
	}
}))

const NewLandingPage = () => {
	const classes = customStyle();
	
	return (
		<React.Fragment>
			<main
				style={{
					display: "grid", gridTemplateRows: "100px 400px 1fr auto", minHeight: "100vh", width: "100vw",
					background: "linear-gradient(#090b13,#191c27 )", color: "#FFF"
				}}>
				<div style={{textAlign: "center"}}>
					<h2>Ocean</h2>
				</div>
				<div style={{textAlign: "center"}}>
					<h1 className={classes.mainTitle}>Contatta la tua ASL</h1>
					<h3 className={classes.subTitle}>
						Utilizza il seguente modulo per la ricerca di informazioni in ambito sanitario da te desiderate navigando
						tra le varie categorie o domande e risposte che torvi sotto. Non è quello che stavi cercando? Apri un ticket
						selezionando dapprima una categoria e poi compilando il form come richiesto.
					</h3>
				</div>
				<div style={{
					display: "flex",
					placeContent: "center center",
					flexFlow: "row wrap",
					padding: 20,
				}}>
					<h2 style={{width: "100%", flexGrow: 1, textAlign: "center"}}>
						CATEGORIE
					</h2>
					<div className={classes.card}>
						<img src={"https://www.fondazioneveronesi.it/uploads/2021/06/10/vaccinazioniadolescenti.jpg"}
						     alt={"Vaccini"} className={classes.image}/>
						<h6 className={classes.categoryName}>Vaccinazioni</h6>
					</div>
					<div className={classes.card}>
						<img src={"https://www.fondazioneveronesi.it/uploads/2021/06/10/vaccinazioniadolescenti.jpg"}
						     alt={"Vaccini"} className={classes.image}/>
						<h6 className={classes.categoryName}>Esoneri vaccinali</h6>
					</div>
					<div className={classes.card}>
						<img src={"https://larc.it/wp-content/uploads/2020/07/TAMPONE-CORONAVIRUS-COVID-scaled.jpg"}
						     alt={"Vaccini"} className={classes.image}/>
						<h6 className={classes.categoryName}>Tamponi</h6>
					</div>
					<div className={classes.card}>
						<img
							src={"https://ilfattoalimentare.it/wp-content/uploads/2020/03/coronavirus-raffreddore-influenza-donna-sintomi-malattia-AdobeStock_231028425-scaled.jpeg"}
							alt={"Vaccini"} className={classes.image}/>
						<h6 className={classes.categoryName}>Isolamento</h6>
					</div>
					<div className={classes.card}>
						<img src={"https://www.ilromeno.com/wp-content/uploads/2020/08/ingresso-in-italia.jpg"}
						     alt={"Vaccini"} className={classes.image}/>
						<h6 className={classes.categoryName}>Rientro in Italia</h6>
					</div>
					<div className={classes.card}>
						<img src={"https://www.donnamoderna.com/content/uploads/2022/04/green-pass.jpg"}
						     alt={"Vaccini"} className={classes.image}/>
						<h6 className={classes.categoryName}>Certificazione Verde</h6>
					</div>
				</div>
				<div style={{
					display: "flex",
					placeContent: "center center",
					flexFlow: "row wrap",
					padding: 20,
				}}>
					<h2>
						FAQ
					</h2>
					<div className={classes.faq}>
						faq con shadow...
					</div>
					<div className={classes.faq}>
						faq con shadow...
					</div>
					<div className={classes.faq}>
						faq con shadow...
					</div>
					<div className={classes.faq}>
						faq con shadow...
					</div>
					<div className={classes.faq}>
						faq con shadow...
					</div>
					<div className={classes.faq}>
						faq con shadow...
					</div>
				</div>
				{/*lang btn + up btn*/}
			</main>
		</React.Fragment>
	);
};

export default React.memo(NewLandingPage);
